import { render, staticRenderFns } from "./FbFileViewFile.vue?vue&type=template&id=232e0fd0"
import script from "./FbFileViewFile.vue?vue&type=script&lang=js"
export * from "./FbFileViewFile.vue?vue&type=script&lang=js"
import style0 from "./FbFileViewFile.vue?vue&type=style&index=0&id=232e0fd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports